import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Descriptions } from 'antd';
import listApi from '../../services/api';

export default function HistoryCart({userData}) {
    
  const [listOrder, setListOrder] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
    
  const fetchListOrder = async () => {
    try {
      const response = await fetch(listApi.listMyOrder, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          session_id: userData.session_id
        })
      });
      const data = await response.json();
      console.log("Check data order----->", data)
      if (data.code === 200) {
        const ordersWithIndex = data.list_order.map((order, index) => ({
            ...order,
            index: index + 1
          }));
          setListOrder(ordersWithIndex);
      }
    } catch (error) {
      console.error("Lỗi khi lấy dữ liệu sản phẩm:", error);
    }
  };

  useEffect(() => {
    fetchListOrder();
  }, [userData]);

  const columns = [
    {
      title: 'STT',
      dataIndex: 'index',
      key: 'index',
    },
    // {
    //     title: 'Sản phẩm',
    //     dataIndex: 'list_item',
    //     key: 'list_item',
    //     render: (list_item) => (
    //       <ul>
    //         {list_item.map(item => (
    //           <li key={item.id}>{item.product_name} - {item.number_item} x {item.price_item.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' })}</li>
    //         ))}
    //       </ul>
    //     ),
    //   },
    {
      title: 'Thời gian tạo',
      dataIndex: 'create_time',
      key: 'create_time',
    },
    {
      title: 'Tổng tiền',
      dataIndex: 'total_order',
      key: 'total_order',
      render: (text, record) => (
      text.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' })
      ),
    },
    {
      title: 'Trạng thái',
      dataIndex: 'state_id',
      key: 'state_id',
      render: (state_id) => (state_id === 1 ? 'Chờ xác nhận' : 'Đã xác nhận'),
    },
    {
      title: 'Hành động',
      key: 'action',
      render: (text, record) => (
        <Button type="primary" onClick={() => handleViewOrder(record)}>
          Xem chi tiết
        </Button>
      ),
    },
  ];

  const handleViewOrder = (order) => {
    setSelectedOrder(order);
    setIsModalVisible(true);
  };

  const handleConfirmOrder = () => {
    // Xử lý xác nhận đơn hàng ở đây
    console.log('Xác nhận đơn hàng:', selectedOrder);
    setIsModalVisible(false);
  };

  return (
    <div>
      <Table columns={columns} dataSource={listOrder} rowKey="ID" />
      <Modal
        title="Chi tiết đơn hàng"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={[
          <Button key="back" onClick={() => setIsModalVisible(false)}>
            Đóng
          </Button>,
        ]}
      >
 
 {selectedOrder && (
          <Descriptions bordered column={1}>
            <Descriptions.Item label="Tên khách hàng">{selectedOrder.name}</Descriptions.Item>
            <Descriptions.Item label="Điện thoại">{selectedOrder.tel}</Descriptions.Item>
            <Descriptions.Item label="Danh sách sản phẩm">
              {selectedOrder.list_item.map(item => (
                console.log("Check selected order--->", {selectedOrder}),
                <div key={item.id}>
                  <p>{item.product_name} - {item.number_item} x {item.price_item.toLocaleString()}đ</p>
                </div>
              ))}
            </Descriptions.Item>
            <Descriptions.Item label="Tổng số tiền">
              {selectedOrder.total_order !== null && selectedOrder.total_order !== undefined
                ? selectedOrder.total_order.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' })
                : 'Không xác định'}
            </Descriptions.Item>
            <Descriptions.Item label="Trạng thái">{selectedOrder.state?.State || 'Không xác định'}</Descriptions.Item>
          </Descriptions>
        )}

      </Modal>
    </div>
  );
}
